<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    data-url="admin/nsr/"
    data-key="items"
    :extra-params="{ work_order_id: workOrder.id }"
    :refresh-trigger.sync="innerRefreshTrigger"
    :extra-filters="extraFilters"
    v-bind="$attrs"
  >
    <template #item.actions="{ item, index }">
      <v-btn color="primary" text @click="onAddClicked(item, index)">
        Add
      </v-btn>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";

export default {
  name: "NsrItemSearchList",
  components: { RemotePaginatedList },
  props: {
    workOrder: Object,
    extraFilters: Object,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      {
        text: root.$t("item.item_no"),
        value: "item_no",
        width: 150,
        sortable: false,
      },
      {
        text: root.$t("item.descriptions"),
        value: "action_description",
        sortable: false,
      },
      {
        text: root.$t("item.unit"),
        value: "unit",
        width: 100,
        sortable: false,
      },
      {
        text: root.$t("item.rate"),
        value: "value",
        width: 100,
        sortable: false,
      },
      { text: "", value: "actions", sortable: false, width: 50 },
    ]);
    const innerRefreshTrigger = ref(false);

    const onAddClicked = function (item, idx) {
      emit("add", item);
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      onAddClicked,
    };
  },
};
</script>
